import { render, staticRenderFns } from "./WholesalersDetail.vue?vue&type=template&id=65951903&"
import script from "./WholesalersDetail.vue?vue&type=script&lang=js&"
export * from "./WholesalersDetail.vue?vue&type=script&lang=js&"
import style0 from "./WholesalersDetail.vue?vue&type=style&index=0&id=65951903&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports